module.exports = {
  translate: [ 'value', require('./translate') ]
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/i18n/translate/index.js